import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377dac66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "action-result-message error"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "action-result-message success"
}

import { withDefaults } from "vue";

type ModalProps = {
  hasError: boolean;
  errorMessages: string[];
};

//#region PROPS

export default /*#__PURE__*/_defineComponent({
  props: {
    hasError: { type: Boolean, default: false },
    errorMessages: null
  },
  setup(__props: any) {

const props = __props as { hasError: boolean, errorMessages: string[] }



//#endregion

return (_ctx: any,_cache: any) => {
  return (props.hasError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.errorMessages.length < 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Error: " + _toDisplayString(props.errorMessages[0]), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errorMessages, (msg, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(msg), 1))
                }), 128))
              ])
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, " Command successfully executed "))
}
}

})